import React, { useEffect } from "react";
import { useForm } from "react-hook-form";

const ApplyDuesModal = ({ isOpen, onClose, onSubmit, initialData }) => {
  const { register, handleSubmit, reset, setValue } = useForm();

  const handleFormSubmit = (data) => {
    // Transform data to match backend expected format
    const transformedData = {
      sessionName: data.sessionName || "March-2024",
      duesType: data.duesType,
      amount: parseFloat(data.duesAmount),
      description: data.description,
      employeeId: data.employeeName ? parseInt(data.employeeName) : null
    };

    onSubmit(transformedData);
    reset();
    onClose();
  };

  useEffect(() => {
    if (initialData) {
      // Set form fields with initial data when editing
      setValue("sessionName", initialData.sessionName || "March-2024");
      setValue("duesType", initialData.duesType);
      setValue("duesAmount", initialData.amount);
      setValue("description", initialData.description);
      setValue("employeeName", initialData.employeeId);
    } else {
      reset(); // Clear the form when no initial data is provided
    }
  }, [initialData, setValue, reset]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md">
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-lg font-medium">
            {initialData ? "Edit Dues for Employee" : "Apply Dues to Employee"}
          </h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit(handleFormSubmit)} className="p-4 space-y-4">
          <div>
            <label className="block text-sm font-medium">Session Name</label>
            <input
              type="text"
              className="mt-1 w-full border border-gray-300 rounded px-3 py-2"
              defaultValue="March-2024"
              {...register("sessionName")}
              readOnly
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Employee Name *</label>
            <select
              className="mt-1 w-full border border-gray-300 rounded px-3 py-2"
              {...register("employeeName", { required: true })}
            >
              <option value="" disabled>
                Select option
              </option>
              <option value="1">Ahmad Raza (IT)</option>
              {/* Add more employee options as needed */}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium">Dues Type *</label>
            <select
              className="mt-1 w-full border border-gray-300 rounded px-3 py-2"
              {...register("duesType", { required: true })}
            >
              <option value="" disabled>
                Select Type
              </option>
              <option value="Loan Recovery">Loan Recovery</option>
              <option value="Other">Other</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium">Dues Amount *</label>
            <input
              type="number"
              className="mt-1 w-full border border-gray-300 rounded px-3 py-2"
              {...register("duesAmount", { required: true })}
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Description</label>
            <textarea
              className="mt-1 w-full border border-gray-300 rounded px-3 py-2"
              {...register("description")}
              placeholder="Enter description"
            ></textarea>
          </div>
          <div className="flex justify-end space-x-2">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-[#231763] text-white px-4 py-2 rounded"
            >
              {initialData ? "Update Dues" : "Apply Dues"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ApplyDuesModal;